import React from 'react';

const Logo = () => (
  <div className="logo">
    <svg className="cloud" xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24"><path d="M18.944,11.112C18.507,7.67,15.56,5,12,5C9.244,5,6.85,6.611,5.757,9.15C3.609,9.792,2,11.82,2,14c0,2.757,2.243,5,5,5h11 c2.206,0,4-1.794,4-4C22,13.12,20.695,11.538,18.944,11.112z" /></svg>
    <p className="dream">Dream</p>
    <p className="stream">Stream</p>
  </div>
);

export default Logo;
